import { DatePipe, NgIf, NgOptimizedImage } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { CardModule } from "src/app/common/components/card/card.module";
import { IconModule } from "src/app/shared/ui/icon/icon.module";
import { TagComponent } from "src/app/shared/ui/tag/tag.component";
import { CommunalPlatformNewsEntry, NetzeBwNewsEntry } from "../../../../news/news.interfaces";

@Component({
  selector: "tpm-news-carousel-item",
  templateUrl: "news-carousel-item.component.html",
  styleUrls: ["news-carousel-item.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, NgOptimizedImage, DatePipe, CardModule, IconModule, TagComponent]
})
export class NewsCarouselItemComponent {
  @Input({ required: true }) public props: NetzeBwNewsEntry | CommunalPlatformNewsEntry;
  @Input() public isMobile: boolean;
  @Input() public showBadge: boolean;
}
